import { checkMot } from '../../../../../ressources/functionJS/checkMot';
import {
  section,
  sous_section,
} from '../../../../../ressources/glossaires/glossaire_type_d_objet_associe_a_un_rapport';

const TYPES_SECTION_RAPPORT = new Set([section, sous_section]);

const estTypeSectionRapport = (objet = {}) =>
  TYPES_SECTION_RAPPORT.has(Number(objet.report_object_type));

/**
 * Nom affiché pour un objet de rapport de premier niveau.
 * @param objet: objet du body_page
 * @return {string}
 */
const nomSection = (objet = {}) =>
  objet.section_name ||
  objet.sub_section_name ||
  objet.graph_name ||
  objet.view_name ||
  objet.undefined_name ||
  objet.date_name ||
  checkMot('section');

const normaliserSection = (objet = {}) => ({
  ...objet,
  section_name: objet.section_name || nomSection(objet),
});

/**
 * Construit la liste des sections du gabarit affichée dans la popup.
 * @param gabarit: gabarit de rapport
 * @return {Array} sections du rapport
 */
export const construireArborescenceRapport = (gabarit = {}) =>
  (function extraireSections(objectsList, chemin) {
    if (!Array.isArray(objectsList)) {
      return [];
    }

    return objectsList.reduce((sections, objet, index) => {
      const id = chemin + '[' + index + ']';
      const enfants = extraireSections(
        objet?.objects_list,
        id + '.objects_list'
      );

      if (!estTypeSectionRapport(objet)) {
        return [...sections, ...enfants];
      }

      return [
        ...sections,
        {
          id,
          libelle: nomSection(objet),
          source: objet,
        },
        ...enfants,
      ];
    }, []);
  })(
    Array.isArray(gabarit?.body_page?.objects_list)
      ? gabarit.body_page.objects_list
      : [],
    'body_page.objects_list'
  );

/**
 * Filtre les objets de body_page : les sections décochées sont retirées.
 * @param objectsList: liste d'objets du body_page
 * @param selection: Set des identifiants cochés
 * @return {Array} objets conservés
 */
const filtrerObjetsBody = (
  objectsList,
  selection,
  chemin = 'body_page.objects_list'
) => {
  if (!Array.isArray(objectsList)) {
    return [];
  }

  return objectsList.reduce((liste, objet, index) => {
    const id = chemin + '[' + index + ']';
    const enfantsFiltres = filtrerObjetsBody(
      objet?.objects_list,
      selection,
      id + '.objects_list'
    );

    if (estTypeSectionRapport(objet) && !selection.has(id)) {
      return liste;
    }

    const objetAvecEnfants = Array.isArray(objet?.objects_list)
      ? { ...objet, objects_list: enfantsFiltres }
      : objet;

    if (!estTypeSectionRapport(objetAvecEnfants)) {
      return [...liste, objetAvecEnfants];
    }

    return [...liste, normaliserSection(objetAvecEnfants)];
  }, []);
};

/**
 * Reconstruit un gabarit en ne conservant que les sections sélectionnées.
 * @param gabarit: gabarit source
 * @param idsSelectionnes: ids des sections cochées
 * @return {Object} gabarit filtré
 */
export const construireGabaritFiltre = (gabarit = {}, idsSelectionnes = []) => {
  const selection = new Set(idsSelectionnes);
  return {
    ...gabarit,
    graphical_charter: gabarit.graphical_charter
      ? { ...gabarit.graphical_charter }
      : gabarit.graphical_charter,
    cover_page: gabarit.cover_page
      ? { ...gabarit.cover_page }
      : gabarit.cover_page,
    body_page: {
      ...(gabarit.body_page || {}),
      objects_list: filtrerObjetsBody(
        gabarit?.body_page?.objects_list,
        selection
      ),
    },
  };
};
